export const MT5_ACCOUNT_STATUS = Object.freeze({
    FAILED: 'failed',
    MIGRATED_WITH_POSITION: 'migrated_with_position',
    MIGRATED_WITHOUT_POSITION: 'migrated_without_position',
    NEED_VERIFICATION: 'need_verification',
    PENDING: 'pending',
    POA_PENDING: 'poa_pending',
    POA_VERIFIED: 'poa_verified',
});
